import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAllCategories } from "../Firebase";
import CategoryShimmer from "./CategoryShimmer";
import "../css/Category.css";

export default function Category(props) {
  const dUid = props.dUid;

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    getAllCategories((result) => {
      setCategories(result)
    })
  },[])

  return categories?.length === 0 ? (
    <CategoryShimmer />
  ) : (
    <div className="agentinfobox-container">
      <div className="category-heading">
        <p className="category-title">Projects</p>
      </div>
  
      <div className="grid">
        {categories.map((category) => (
          <Link
            key={category.NAME} // Using a unique key instead of index
            className="linkClass"
            to={{
              pathname: category.NAME === "Loan" ? "/Projects/Loans" : "/Projects",
              search: `?category=${category.NAME}&dist=${dUid}`,
            }}
          >
            <div className="grid-item">
              <img src={category.LOGO} alt={category.NAME} className="categoryImage" />
              <p className="categoryName">{category.NAME}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
  
}